
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';
import pricingServices from '@/services/pricing-services';

@Component
export default class ListPricing extends Vue {
    @Prop({default: {}})
    private listItem: any;
    @Prop({default: {}})
    private pageSettings: any;

    private eventEmit = {
        eventViewDetail: 'eventViewDetail'
    };

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private async viewDetail(id) {
        this.$emit(this.eventEmit.eventViewDetail, id);
    }
}
